import { Constants } from 'core';

export const isRequestError = (error: string) => {
  const RequestError = [
    'CLIENT_ERROR',
    'SERVER_ERROR',
    'TIMEOUT_ERROR',
    'CONNECTION_ERROR',
    'NETWORK_ERROR',
    'UNKNOWN_ERROR',
    'CANCEL_ERROR',
    Constants.ALREADY_EXISTED_PROBLEM_CODE,
    'unknown',
  ];
  return RequestError.includes(error);
};
